<template>
  <v-tooltip v-bind="tooltipAlignment" :color="tooltipColor" :disabled="disabled">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        @click="$emit('click')"
        :disabled="disabled"
        x-small
        text
        icon
        :style="buttonStyle"
      >
        <v-icon :color="selected ? 'var(--app-primary-base)' : iconColor" :size="iconSize">
          {{ icon }}
        </v-icon>
      </v-btn>
    </template>

    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "HomeFormTableToolbarButton",

  props: {
    icon: {
      type: String,
      required: true
    },

    iconSize: {
      type: Number,
      default: 12
    },

    tooltip: {
      type: String,
      required: false
    },

    selected: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    tooltipPosition: {
      type: String,
      default: 'top',
    },

    iconColor: {
      type: String,
      default: 'primary',
    },

    tooltipColor: {
      type: String,
      default: undefined,
    },

    buttonStyle: {
      type: Object,
      default: () => ({
        width: '22px',
        height: '22px',
        margin: '0'
      }),
    },
  },

  computed: {
    tooltipAlignment() {
      let alignment = {}
      alignment['' + this.tooltipPosition] = true;
      return alignment;
    },
  }
};
</script>

<style scoped>
.v-tooltip__content {
  border-radius: 8px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Atoms/TableToolbarButton.vue